import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useWindowSize } from 'react-use';

import { havedebit } from '../../api/ans';
import balanceIcon from '../../assets/images/balanceIcon.svg';
import { openPopup } from '../../store/slices/popupSlice';
import { clearSelected, replaceStocks } from '../../store/slices/stocksSlice';
import { fetchUserInfo } from '../../store/slices/userSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import GreyButton from '../ui/buttons/greyButton/GreyButton';
import RedButton from '../ui/buttons/redButton/RedButton';
import UserMenuDropdown from '../UserMenuDropdown/UserMenuDropdown';
import styles from './styles/styles.module.css';

function Header() {
  const user = useAppSelector((state) => state.user.data);
  const isLegalEntity = user?.type !== 'individual';
  // const user = {sign_agree: false};
  const { width } = useWindowSize();
  const [debist, setDebit] = useState(false);
  const dispatch = useAppDispatch();
  const balance = useAppSelector((state) => state.cards.balance);
  // const counter = '2';
  const { error, fetchStatus } = useAppSelector((state) => state.user);
  const data = useAppSelector((state) => state.user);
  console.log(data);
  const isLoading = fetchStatus === 'loading';

  const location = useLocation();
  const navigate = useNavigate();

  const isDisabled = location.pathname === '/send' || location.pathname === '/refund';

  // isMobile - чистая производная от width, не отдельное состояние.
  // React Compiler ESLint правило (react-hooks/set-state-in-effect) верно
  // указало: не нужен эффект+состояние там, где можно вычислить прямо
  // при рендере - убирает лишний ре-рендер и задержку в один кадр.
  const isMobile = width < 480;

  useEffect(() => {
    havedebit().then((result) => {
      setDebit(result);
    });
  }, []);

  const handleRedButtonClick = () => {
    if (debist) {
      dispatch(openPopup('negativeBalance'));
    } else if (!user.sign_agree) dispatch(openPopup('SignAgree'));
    else {
      dispatch(clearSelected());
      navigate('/send');
    }
  };

  const handleGreyButtonClick = () => {
    dispatch(replaceStocks([]));
    console.log('handlegreybuttonclick');
    if (debist) dispatch(openPopup('negativeBalance'));
    else if (!user.sign_agree && isLegalEntity) dispatch(openPopup('SignAgree'));
    else navigate('/refund');
  };

  const handleBalanceButtonClick = () => {
    navigate('/balance');
  };

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, [dispatch]);

  return (
    <header
      className={`${styles.headerWrapper}
        ${location.pathname.includes('orders/') && width < 480 ? styles.dis : ''}`}
    >
      {isLoading && <div className={styles.headerLoading}>Загрузка...</div>}
      {/* {error && <div className={styles.headerError}>{error}</div>} */}
      {(isMobile && location.pathname !== '/refund' && location.pathname !== '/add') ||
      !isMobile ? (
        <div
          className={
            location.pathname.includes('orders/') && width < 480
              ? styles.headerButtonsWrapperDis
              : styles.headerButtonsWrapper
          }
        >
          <GreyButton
            text="Забрать"
            width={128}
            height={isMobile ? 36 : 'auto'}
            disabled={isDisabled || isLoading || error}
            onClick={handleGreyButtonClick}
          />
          <RedButton
            text="Сдать вещи"
            plusRight
            onClick={handleRedButtonClick}
            disabled={isDisabled || isLoading || error}
            height={isMobile ? 36 : 'auto'}
            smallText
          />
        </div>
      ) : (
        <div />
      )}
      <div className={`${styles.userButtonsWrapper}`}>
        <UserMenuDropdown isDisabled={!!error} />
        <div
          className={`${styles.noteBalanseSector} ${error ? styles.userButtonsWrapperDisable : ''}`}
        >
          <button
            className={`${styles.headerButtons} ${styles.balanceButton}`}
            type="button"
            onClick={error ? () => {} : handleBalanceButtonClick}
            disabled={isLoading}
          >
            <img src={balanceIcon} alt="иконка баланс" />
            {`${Number(balance?.balance ? balance?.balance : '').toFixed(2)} ₽`}
          </button>
          <button
            className={`${styles.headerButtons} ${styles.notificationButton}`}
            disabled={isLoading}
            onClick={error ? () => {} : () => navigate('/notifications')}
          >
            {/* {counter && <div className={styles.headerNotificationCounter}>{counter}</div>} */}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
